import React, { useState, useEffect } from "react";
import DataTable from "../../components/DataTable";
import SnackbarAlert from "../../components/SnackbarAlert";
import { Box, TextField, IconButton, Tooltip, Typography, Button, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, MenuItem, } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { webEndPoint } from '../../constants/globalConstants';
import { makeRequest } from "../../services/api";
export default function DistrictPage() {
    const [districts, setDistricts] = useState([]);
    const [search, setSearch] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [selectedState, setSelectedState] = useState("");
    const [states, setStates] = useState([]);
    const [editDistrict, setEditDistrict] = useState(null);
    const [districtName, setDistrictName] = useState("");
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        fetchDistricts();
        fetchstates();
    }, []);
    const fetchstates = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "states";
            const response = await makeRequest("get", url);
            if (response) {
                setStates(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchDistricts = async () => {
        setLoading(true);
        try {
            let url = webEndPoint + "districts";
            const response = await makeRequest("get", url);
            if (response) {
                setDistricts(response?.data);
                setLoading(false);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const openAddModal = () => {
        setEditDistrict(null);
        setDistrictName("");
        setOpenModal(true);
    };
    const handleEdit = (district) => {
        setEditDistrict(district);
        setSelectedState(district.state_id);
        setDistrictName(district.district_name);
        setOpenModal(true);
    };
    const handleSave = async () => {
        if (!districtName.trim()) {
            setMessage("District name required");
            setSnackbar(true);
            return;
        }
        setLoading(true);
        try {
            if (editDistrict) {
                const stateEditData = {
                    district_name: districtName,
                    state_id: selectedState
                };
                try {
                    let url = webEndPoint + "districts/" + editDistrict?.rfId;
                    const response = await makeRequest("put", url, stateEditData);
                    if (response) {
                        setLoading(false);
                        setMessage("District Updated Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            } else {
                const districtAddData = {
                    district_name: districtName,
                    state_id: selectedState
                };
                try {
                    let url = webEndPoint + "districts";
                    const response = await makeRequest("post", url, districtAddData);
                    if (response) {
                        setLoading(false);
                        setMessage("District Added Successfully");
                    }
                } catch (err) {
                    console.error(err);
                } finally {
                    setLoading(false);
                }
            }
            fetchDistricts();
            setSnackbar(true);
            setOpenModal(false);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    const filteredDistricts = districts?.filter((d) =>
        d?.district_name?.toLowerCase().includes(search?.toLowerCase())
    );
    const columns = ["S.No", "State Code", "State Name", "District Name", "Action"];
    const rows = filteredDistricts?.map((district, index) => [index + 1, district.state_code, district.state_name, district.district_name,
    <Box>
        <Tooltip title="Edit District">
            <IconButton color="primary" onClick={() => handleEdit(district)}>
                <EditIcon />
            </IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ position: "relative" }}>
            {loading && (
                <Box sx={{ position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", backgroundColor: "rgba(255,255,255,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999, }}>
                    <CircularProgress />
                </Box>
            )}
            <Typography variant="h6" sx={{ mb: 3, fontWeight: 500 }}>District Master</Typography>
            <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2, alignItems: { xs: "stretch", sm: "center" }, justifyContent: "space-between", mb: 2, width: "100%", }}>
                <TextField label="Search District" size="small" value={search} onChange={(e) => setSearch(e.target.value)} sx={{ width: { xs: "100%", sm: "70%", md: 600 } }} />
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAddModal} sx={{ width: { xs: "100%", sm: "auto" }, }}>Add District</Button>
            </Box>
            <DataTable columns={columns} rows={rows} />
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
            <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth maxWidth="sm">
                <DialogTitle>{editDistrict ? "Edit District" : "Add District"}</DialogTitle>
                <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
                    <TextField select label="Select State" value={selectedState} onChange={(e) => setSelectedState(e.target.value)} sx={{ mt: 2 }} fullWidth>
                        {states.map((state) => (
                            <MenuItem key={state.rfId} value={state.rfId}>{state.state_name}</MenuItem>
                        ))}
                    </TextField>
                    <TextField label="District Name" value={districtName} onChange={(e) => setDistrictName(e.target.value)} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenModal(false)}>Cancel</Button>
                    <Button variant="contained" onClick={handleSave}>{editDistrict ? "Update" : "Save"}</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}